import type { CaseDocumentSort } from '@/services/api/cases'

export const NEWEST_UPLOAD_FIRST: CaseDocumentSort = { by: 'uploaded', order: 'desc' }

/**
 * The order after a click on a time column: that time, newest first; another click on the column
 * that already sorts turns its order round.
 */
export function nextSort(current: CaseDocumentSort, by: CaseDocumentSort['by']): CaseDocumentSort {
  return { by, order: current.by === by && current.order === 'desc' ? 'asc' : 'desc' }
}
